<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="contrast w1200">
			<div class="flex famous_position">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/career" class="cl_gray">生涯规划</router-link>
					  >  <router-link to="/choice" class="cl_gray">3+2+1选科</router-link>  >  科目组合对比</p>
				</div>
			</div>
			<div class="contrast_title flex">
				<h3 class="f18px bold">科目组合对比</h3>
				<router-link to="/choice_collect" class="contrast_title_coll cl_white tc">我收藏的组合</router-link>
			</div>
			<div class="contrast_cont">
				<div class="contrast_l tc">
					<table class="contrast_l_table">
						<thead>
							<tr>
								<td colspan="2" class="f18px cl_gray table_l_add_td"><div class="table_l_add">+&nbsp;&nbsp;增加科目组合</div></td>
							</tr>
						</thead>
						<tbody class="bg_gray">
							<tr>
								<td colspan="2">
									<h3 class="f18px">兴趣优势学科</h3>
									<p class="cl_dark mat5">(依据学科测评)</p>
								</td>
							</tr>
							<tr>
								<td colspan="2">
									<h3 class="f18px">潜能优势学科</h3>
									<p class="cl_dark mat5">(依据学科测评)</p>
								</td>
							</tr>
							<tr>
								<td colspan="2">
									<h3 class="f18px">学科要求</h3>
									<p class="cl_dark mat5">(理解/背诵)</p>
								</td>
							</tr>
							<tr>
								<td colspan="2"><h3 class="f18px">文理偏向</h3></td>
							</tr>
							<tr>
								<td colspan="2"><h3 class="f18px">专业覆盖率</h3></td>
							</tr>
							<tr>
								<td rowspan="12">
									<h3 class="f18px">可报考门类比例</h3>
									<p class="cl_dark">(本科)</p>
								</td>
								<td class="table_l_subject"><h3 class="f18px">哲学</h3></td>
							</tr>
							<tr>
								<td class="table_l_subject"><h3 class="f18px">经济学</h3></td>
							</tr>
							<tr>
								<td class="table_l_subject"><h3 class="f18px">法学</h3></td>
							</tr>
							<tr>
								<td class="table_l_subject"><h3 class="f18px">教育学</h3></td>
							</tr>
							<tr>
								<td class="table_l_subject"><h3 class="f18px">文学</h3></td>
							</tr>
							<tr>
								<td class="table_l_subject"><h3 class="f18px">历史学</h3></td>
							</tr>
							<tr>
								<td class="table_l_subject"><h3 class="f18px">理学</h3></td>
							</tr>
							<tr>
								<td class="table_l_subject"><h3 class="f18px">工学</h3></td>
							</tr>
							<tr>
								<td class="table_l_subject"><h3 class="f18px">农学</h3></td>
							</tr>
							<tr>
								<td class="table_l_subject"><h3 class="f18px">医学</h3></td>
							</tr>
							<tr>
								<td class="table_l_subject"><h3 class="f18px">管理学</h3></td>
							</tr>
							<tr>
								<td class="table_l_subject"><h3 class="f18px">艺术学</h3></td>
							</tr>
							<tr>
								<td colspan="2"><h3 class="f18px">是否可报考收藏的院校专业</h3></td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="contrast_r">
					<div class="contrast_r_table inline" v-for="(item,index) in cont" :key="index">
						<div class="table_r_title">
							<div class="table_r_title_div">
								<div class="table_r_titlt_top flex">
									<p class="f16px cl_gray">科目组合{{index+1}}：</p>
									<img src="../../../static/close_violet.png" @click="subDelete(index)" />
								</div>
								<div class="table_r_title_mid f18px bold mat5">{{item.subject[0]}}+{{item.subject[1]}}+{{item.subject[2]}}</div>
								<div class="table_r_title_btm f16px tc mat15">
									<p class="cl_gray" v-if="item.my == true">我的模拟选科</p>
									<span class="cl_violet" v-else @click="subCheck(index)">选为模拟选科</span>
								</div>
							</div>
						</div>
						<div class="f18px cl_dark table_r_body">
							<div class="table_r_td"><div class="table_r_div">{{item.xq}}</div></div>
							<div class="table_r_td"><div class="table_r_div">{{item.qn}}</div></div>
							<div class="table_r_td"><div class="table_r_div">{{item.yq}}</div></div>
							<div class="table_r_td"><p>{{item.px}}</p></div>
							<div class="table_r_td"><p>{{item.fg}}</p></div>
							<div class="table_r_td"><p>{{item.sub1}}</p></div>
							<div class="table_r_td"><p>{{item.sub2}}</p></div>
							<div class="table_r_td"><p>{{item.sub3}}</p></div>
							<div class="table_r_td"><p>{{item.sub4}}</p></div>
							<div class="table_r_td"><p>{{item.sub5}}</p></div>
							<div class="table_r_td"><p>{{item.sub6}}</p></div>
							<div class="table_r_td"><p>{{item.sub7}}</p></div>
							<div class="table_r_td"><p>{{item.sub8}}</p></div>
							<div class="table_r_td"><p>{{item.sub9}}</p></div>
							<div class="table_r_td"><p>{{item.sub10}}</p></div>
							<div class="table_r_td"><p>{{item.sub11}}</p></div>
							<div class="table_r_td"><p>{{item.sub12}}</p></div>
							<div class="table_r_td"><p>{{item.sc}}</p></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'contrast',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 1,
				cont: [
					{
						id: 1,
						subject: ["历史", "地理", "政治"], //科目
						my: false, //是否为模拟选科
						xq: "低兴趣：物理，生物",
						qn: "既无强学科也无弱学科",
						yq: "需要很强逻辑数学能力和自然观察能力需要很强逻辑数学能力和自然观察能力。",
						px: "纯理",
						fg: "可报考97.2%的专业",
						sub1: "0.1%",
						sub2: "5.3%",
						sub3: "2.0%",
						sub4: "3.0%",
						sub5: "8.7%",
						sub6: "0.3%",
						sub7: "7.9%",
						sub8: "34.6%",
						sub9: "2.0%",
						sub10: "5.4%",
						sub11: "15.5%",
						sub12: "11.7%",
						sc: "是",
					},{
						id: 1,
						subject: ["历史", "地理", "政治"], //科目
						my: false, //是否为模拟选科
						xq: "低兴趣：物理，生物",
						qn: "既无强学科也无弱学科",
						yq: "需要很强逻辑数学能力和自然观察能力需要很强逻辑数学能力和自然观察能力。",
						px: "纯理",
						fg: "可报考97.2%的专业",
						sub1: "0.1%",
						sub2: "5.3%",
						sub3: "2.0%",
						sub4: "3.0%",
						sub5: "8.7%",
						sub6: "0.3%",
						sub7: "7.9%",
						sub8: "34.6%",
						sub9: "2.0%",
						sub10: "5.4%",
						sub11: "15.5%",
						sub12: "11.7%",
						sc: "是",
					},
				],
			}
		},
		mounted() {
			
		},
		created() {
			
		},
		methods: {
			subDelete (e) {
				
			},
			subCheck (e) {
				
			},
		},
	}
</script>

<style>
</style>
